import css from 'styled-jsx/css';

const styles = css.global`.divider-widget.default {
  display: block;
  border-top: 1px solid #cccccc;
  box-sizing: border-box;
  width: 100%;
  margin: 40px 0;
}
`;

export default styles;